export default __webpack_public_path__ + "static/media/IMG_4471.dab54ad6.jpg";